import {ADICIONAR_FILTRO_CUPOM} from '../types'

export default function adicionarFiltroCupom (filtro) {
  return {
    type: ADICIONAR_FILTRO_CUPOM,
    payload: filtro
  }
}
